// Đếm event telemetry còn nằm trong hàng đợi của MỘT workspace, chưa gửi lên server.
//
// Vì sao `doctor --fix` cần con số này trước khi dời workspace: hàng đợi nằm trong
// `.claude/state/telemetry-queue/`, còn tiến trình flush thì tìm nó qua
// `CLAUDE_PROJECT_DIR` của phiên đang chạy (`flush.py:31-35`). Dời workspace đi lúc
// hàng đợi còn event nghĩa là không phiên nào còn trỏ tới đường cũ ⇒ đúng số event đó
// mất im lặng. Nên con số này là ĐIỀU KIỆN CHẶN, không phải thông tin trang trí.
//
// 3 biến thể tên file, đều tính là "chưa gửi" (đo từ `flush.py`):
//   - `events-*.jsonl`           buffer thường (và cả bản cứu `events-*-salvage-<pid>.jsonl`)
//   - `events-*.jsonl.flushing`  đang bay dở / mồ côi sau khi tiến trình flush chết
//   - `events-*.jsonl.mojibake`  bị cách ly, pre-pass lượt flush sau vẫn xử lý lại
// Đếm THỪA an toàn hơn đếm THIẾU ở đây: thừa thì cùng lắm `--fix` từ chối dời và bảo
// người dùng flush trước; thiếu thì mất dữ liệu.
import { promises as fs } from "node:fs";
import { join } from "node:path";

export const TELEMETRY_QUEUE_RELATIVE = join(".claude", "state", "telemetry-queue");

function isQueueFile(name: string): boolean {
  if (!name.startsWith("events-")) return false;
  return (
    name.endsWith(".jsonl") || name.endsWith(".jsonl.flushing") || name.endsWith(".jsonl.mojibake")
  );
}

/** Số dòng KHÔNG rỗng — mỗi dòng JSONL là 1 event. */
function countNonEmptyLines(content: string): number {
  let n = 0;
  for (const line of content.split("\n")) {
    if (line.trim().length > 0) n += 1;
  }
  return n;
}

/**
 * Trả tổng số event chưa gửi trong `<workspaceRoot>/.claude/state/telemetry-queue/`.
 *
 * Thư mục vắng / không đọc được ⇒ `0`: không có hàng đợi thì không có gì để mất. File
 * lẻ đọc lỗi cũng bỏ qua — một file hỏng không được làm chết cả phép đo, và ca đó đã
 * có `corrupt_lines` bên delivery-health lo.
 */
export async function countQueuedTelemetryEvents(workspaceRoot: string): Promise<number> {
  const dir = join(workspaceRoot, TELEMETRY_QUEUE_RELATIVE);
  let names: string[];
  try {
    names = await fs.readdir(dir);
  } catch {
    return 0;
  }

  let total = 0;
  for (const name of names) {
    if (!isQueueFile(name)) continue;
    try {
      total += countNonEmptyLines(await fs.readFile(join(dir, name), "utf8"));
    } catch {
      // File vừa bị flush xoá giữa readdir và read — bỏ qua, không phải lỗi.
    }
  }
  return total;
}
